import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 67 67"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CD66E5",
      "fill-rule": "evenodd",
      d: "M33.29 0c.067 18.363 14.946 33.228 33.29 33.228-18.385 0-33.29 14.932-33.29 33.352C33.224 48.217 18.345 33.352 0 33.352c18.386 0 33.29-14.933 33.29-33.353",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }